import styled from "styled-components";
import { Device } from "../../../../components/device";

const SecondaryNavigation = styled.nav`
    display: flex;
    flex-direction: row;
    ${Device.tabletLandscape} {
        position: absolute;
        top: 50%; 
        right: 1.5rem;
        transform: translateY(-50%);
    }
    ${Device.desktop} {
        right: 3rem;
    }
    a, button {
        color: var(--app-bar-color, currentColor);
        font-size: 12px;
        letter-spacing: 0.05em;
        font-weight: bold;
        padding: .5rem 0;
        text-transform: uppercase;
        margin-left: 1rem;
        ${Device.laptop} {
            margin-left: 1.5rem;
        }
    }
`;

export default SecondaryNavigation;